(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("LightMotion", [], factory);
	else if(typeof exports === 'object')
		exports["LightMotion"] = factory();
	else
		root["LightMotion"] = factory();
})(this, function() {
return 